module.exports = __webpack_public_path__ + "imgs/greenbits.698b86fe5ff069590dba690466112642.jpg";